import { theme } from "../../../theme/theme";
const style = () => {
    const { colorBgBase, colorBgPrimary, colorText, colorTextMedium, space05, space3, space4, space6 } = theme();
    return {
        activeTabText: {
            color: colorText,
        },
        container: {
            width: "100%",
        },
        indicator: {
            backgroundColor: colorBgPrimary,
            bottom: 0,
            height: space05,
            left: 0,
            position: "absolute",
        },
        tab: {
            marginHorizontal: space3,
            paddingBottom: space4,
        },
        tabText: {
            color: colorTextMedium,
        },
        tabs: {
            alignItems: "center",
            backgroundColor: colorBgBase,
            flexDirection: "row",
            justifyContent: "flex-start",
            paddingHorizontal: space6,
        },
        tabsLarge: {
            justifyContent: "center",
        },
    };
};
export { style };
